module.exports = __webpack_public_path__ + "static/media/icon-spam-white.fac3349c.svg";